export default {
  label: {
    man: 'Homem',
    woman: 'Mulher',
    office: 'Organização',
    notClassified: 'Não Classificados',
  },
};
